require('../../../node_modules/bootstrap/dist/css/bootstrap.min.css');

var $ = require('jquery')

export default {
  name: 'app',
  created: function() {
    this.healthcheck()
    if (!this.$store.getters.isLogin && window.localStorage.getItem('access_token')) {
      this.authorize()
    }
    // 画面タップ時にbootstrapのトグルメニューを閉じる
    if (window.innerWidth <= 769) {
      document.body.onclick = function() {
        $(".navbar-collapse").collapse('hide');
      }
    }
  },
  computed: {
    maintenance () {
      return this.$store.getters.maintenance
    }
  },
  components: {
  },
  methods: {
    authorize: function() {
      this.$store.dispatch('AUTHORIZE')
    },
    healthcheck: function() {
      this.$store.dispatch('HEALTHCHECK')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/app.js